<template>
    <client-only>
        <UiMapLeafletRouteMap
            v-if="pointA && pointB"
            v-editable="blok"
            :blok="blok"
            :pointA="pointA"
            :pointB="pointB"
            :max-height="blok.maxHeight"
            :route-key="locationData?.airport?.code"
            s3-cache-path="sf"
        />
        <!-- If points are not set, show nothing -->
    </client-only>
</template>
<script setup lang="ts">
import { inject, ref, watchEffect } from 'vue';
import type { ICoreShuttleRouteMap } from '@nuxt-monorepo/ui/types/components/Map/CoreShuttleRouteMap';
import { parseLatLng } from '@nuxt-monorepo/ui/utils/helpers';
import type { LatLng } from '@nuxt-monorepo/ui/types/components/Map/ApiProductMap';
import type { IShuttleLocationData } from '@nuxt-monorepo/ui/types/products/ShuttleProducts';

const props = defineProps<{ blok: ICoreShuttleRouteMap }>();

// Get locationData injected from parent (if available)
const locationData = inject('locationData', null) as IShuttleLocationData | null;

// Main map points
const pointA = ref<LatLng | null>(null);
const pointB = ref<LatLng | null>(null);

/** Always use only manual points from blok */
watchEffect(() => {
    pointA.value = parseLatLng(props.blok.pointA);
    pointB.value = parseLatLng(props.blok.pointB);
});
</script>
